import styled, { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
    body {
        //background: linear-gradient(to right, #8296de, #6d6499);
        margin: 0;
        padding: 0;
        min-height: 100vh;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        font-family: 'Pretendard', 'Apple SD Gothic Neo', sans-serif;
    }
`;

export default GlobalStyle;